import axios from 'axios'

import { ApiSourceType } from '~sharedLib'
import { addBaseInterceptors } from '../../lib/functions/addBaseInterceptors'
import { baseConfig } from '../axios/base'

export const secondSourceInstanceApi = axios.create(baseConfig(ApiSourceType.Second))

addBaseInterceptors(secondSourceInstanceApi.interceptors)
